import React from "react";
import styles from "./IconGridModule.module.scss";
import { IconGridOptionsType } from "@/types/ModuleOptionsType";
import { columnSize } from "../../utils/layout/columnSize";
import { IconGridBoxes } from "./IconGridBox/IconGridBoxes";
import { Modul_Icon_Grid } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { getItemWidthBreakpoints } from "@aleksundshantu/aunds-utils-react/primitives/grid";
import { Headline } from "@/components/Headline/Headline";
import { Section } from "@/components/Section/Section";

export type IconGridModuleType = Modul_Icon_Grid;

interface IconGridModuleProps {
  data: IconGridModuleType;
  infoBoxOptions: IconGridOptionsType;
}

const IconGridModule = ({ infoBoxOptions, data }: IconGridModuleProps) => {
  {
    /* jscpd:ignore-start */
  }
  const content = data.icon_grid;

  const { headline, headline_html_tag, overline, subline } = content;

  const elements = content.elements || [];

  const {
    id,
    background_color_class,
    section_margin_class,
    section_padding_class,
    module_width,
    headline_text_align_class,
    text_align_class,
    grid_columns,
    toggle_cardbox,
    trenner_anzeigen,
    title_style,
    icon_align_class,
    flex_direction_class,
    row_direction_class,
  } = data.layout;

  const globalShowBox = infoBoxOptions?.box?.show_card_box ?? false;
  const showCardbox = globalShowBox ? toggle_cardbox : false;

  const { show_overline_subline, columns, grid_columns_choices } =
    infoBoxOptions ?? {
      show_overline_subline: "none",
      columns: { breakpoint: "tablet", number_of_cols: 12 },
      grid_columns_choices: {},
    };

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline ?? "none",
  );

  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }

  const columnSizes =
    module_width !== "normal-frame"
      ? columns
        ? columnSize(columns)
        : "is-12"
      : "is-12";

  const fallbackItemWidth = {
    mobile: "100%",
    tablet: "50%",
    desktop: "50%",
    widescreen: "50%",
    fullhd: "50%",
    ultrahd: "50%",
  };

  const itemWidth = {
    ...getItemWidthBreakpoints(
      grid_columns_choices,
      grid_columns,
      fallbackItemWidth,
    ),
    mobile: "100%",
  };

  const infoBoxesJSX = (
    <div className="columns is-multiline is-centered">
      <div className={`column is-12`}>
        <Headline
          headline={headline}
          headline_html_tag={headline_html_tag}
          overline={showOverline ? overline : ""}
          subline={showSubline ? subline : ""}
          extraClass={headline_text_align_class}
          wrapInSection={module_width === "frameless"}
          disableAnimation
        />
      </div>

      <div className={`column is-12 ${styles["text-infobox"]}`}>
        <IconGridBoxes
          elements={elements}
          infoBoxOptions={infoBoxOptions}
          extraClass={`${text_align_class} ${icon_align_class}`}
          itemWidth={itemWidth}
          show_cardbox={showCardbox}
          show_divider={trenner_anzeigen}
          heading_level={headline ? 3 : 2}
          layoutOptions={{
            title_style,
            icon_align_class,
            flex_direction_class,
            row_direction_class,
            text_align_class,
          }}
          boxType="icon-list"
        />
      </div>
    </div>
  );

  return (
    <Section
      id={id}
      className={`icon-grid ${styles["info-boxes"]} ${background_color_class === "has-gradient-bg" ? styles["is-text-white"] : ""} ${background_color_class} ${section_padding_class} ${section_margin_class}`}
      disableColumns
      frameless={module_width === "frameless"}
    >
      {module_width === "narrow-frame" ? (
        <div className="columns is-centered">
          <div className={`column ${columnSizes} is-centered`}>
            {infoBoxesJSX}
          </div>
        </div>
      ) : (
        infoBoxesJSX
      )}
    </Section>
  );
  {
    /* jscpd:ignore-end */
  }
};

export default IconGridModule;
